var pressArticles = [
    {
        publication: 'Al Jazeera',
        title: "As Gaza starves, GoFundMe accused of blocking 'millions of dollars' raised",
        url: 'https://www.aljazeera.com/news/2025/6/26/as-gaza-starves-gofundme-accused-of-blocking-millions-of-dollars-raised',
        year: '2025',
    },
    {
        publication: 'ABC',
        title: 'As Palestinians starve in Gaza, some are turning to social media and crowdfunding to survive',
        url: 'https://www.abc.net.au/news/2025-08-11/palestinians-starving-in-gaza-using-social-media-to-survive/105581990',
        year: '2025',
    },
    {
        publication: 'BBC',
        title: 'Columbia University protester released after one year in immigration custody',
        url: 'https://www.bbc.com/news/articles/ckgzdkg0q9go',
        year: '2026',
    },
    {
        publication: 'The Guardian',
        title: "Environmental activist Ben Pennings declares 'massive victory' after Adani drops its years-long legal pursuit",
        url: 'https://www.theguardian.com/environment/2025/nov/27/adani-drops-legal-pursuit-environmental-activist-ben-pennings',
        year: '2025',
    },
    {
        publication: 'Truthout',
        title: 'Environmental human rights lawyer Steven Donziger seeks Pardon from President Biden',
        url: 'https://truthout.org/articles/16-groups-urge-biden-to-pardon-lawyer-steven-donziger-who-took-on-chevron/',
        year: '2025',
    },
    {
        publication: 'AnalystNews',
        title: "For Sudan's war-torn communities, crowdfunding is a fragile lifeline",
        url: 'https://www.analystnews.org/posts/sudan-war-torn-crowdfunding-donations-usaid',
        year: '2025',
    },
    {
        publication: 'Newsweek',
        title: 'Mahmoud Khalil Fundraiser Hits New Milestone',
        url: 'https://www.newsweek.com/mahmoud-khalil-fundraiser-hits-new-milestone-2043833',
        year: '2025',
    },
    {
        publication: "It's Going Down",
        title: 'Your Guide on How to Support Mutual Aid Groups in Palestine as Humanitarian Crisis Deepens',
        url: 'https://itsgoingdown.org/your-guide-on-how-to-support-mutual-aid-groups-in-palestine-as-humanitarian-crisis-deepens/',
        year: '2025',
    },
    {
        publication: 'The Guardian',
        title: 'Zoe Rosenberg, 23, on trial for rescuing four chickens in California',
        url: 'https://www.theguardian.com/us-news/2025/oct/24/chicken-rescue-factory-farm',
        year: '2025',
    },
];
export default pressArticles;
